// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Manuais_containerPrincipal__JLPYN","divManuais":"Manuais_divManuais__AzpBX"};